import { Box, Skeleton } from "@mui/material";

export default function LoadingTextBody() {
  return (
    <Box>
      <Skeleton height={30} />
      <Skeleton height={30} />
      <Skeleton height={30} width="30%" />
    </Box>
  );
}
